import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core';
import { SetContextLink } from '@apollo/client/link/context';

type AccessTokenProvider = () => Promise<string | undefined>;

export type GraphQLClientDependencies = {
  getAccessToken: AccessTokenProvider;
  fetch?: typeof globalThis.fetch;
  headers?: Record<string, string>;
};

export const initializeGraphQLClient = (uri: string, dependencies: GraphQLClientDependencies) => {
  const httpLink = new HttpLink({
    uri,
    fetch: dependencies.fetch,
  });
  const authenticationLink = new SetContextLink(async (context) => {
    const accessToken = await dependencies.getAccessToken();
    const operationHeaders = (context.headers ?? {}) as Record<string, string>;

    return {
      headers: {
        ...operationHeaders,
        ...dependencies.headers,
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    };
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: authenticationLink.concat(httpLink),
    defaultOptions: {
      watchQuery: { fetchPolicy: 'cache-and-network' },
    },
  });
};
